import './index.less';
import * as React from 'react';
import { connect } from 'react-redux';
import { Layout, Menu, Icon, Tooltip } from '@beehive/components';
import { MenuType } from 'modules/types/account';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';
import messages from 'messages/Main';
import { FormattedMessage } from 'react-intl';
import { localPx2rem } from '@mpc/common/src/utils';
import { BookmarkFilled, ComputerFilled, HotelFilled, ShoppingBagFilled } from '@bedrock/icons-react';
import { Badge } from '@bedrock/components';

const MENU_DIVIDER_KEY = 'beehive-menu-divider';

const GROUPPED_MENU_KEYS = ['smWorkbench', 'lsWorkbench'];
const GROUPPED_MENU_CHILD_KEYS = [
  'smWorkbench',
  'companyManagement',
  'lsWorkbench',
  'lsCompanyManagement',
];

const GROUP_MENU_SM = {
  key: 'socialMediaGroup',
  name: 'socialMediaGroup',
};
const GROUP_MENU_LS = {
  key: 'liveStreamingGroup',
  name: 'liveStreamingGroup',
};
const GROUP_MENU_MAPPING = {
  smWorkbench: GROUP_MENU_SM,
  companyManagement: GROUP_MENU_SM,
  lsWorkbench: GROUP_MENU_LS,
  lsCompanyManagement: GROUP_MENU_LS,
};
const GROUP_MENU_KEYS = [GROUP_MENU_SM.key, GROUP_MENU_LS.key];

const getGrouppedMenus = (menus: MenuType[]) => {
  const grouppedMenus: MenuType[] = [];

  if (menus.length > 0) {
    const hasToShowGroup = _.every(GROUPPED_MENU_KEYS, (key: string) => {
      return !!~_.findIndex(menus, (menu: MenuType) => menu.key === key);
    });

    menus.forEach((menu: MenuType) => {
      const menuKey = menu.key;
      if (hasToShowGroup && GROUPPED_MENU_CHILD_KEYS.includes(menuKey)) {
        const groupMenu = GROUP_MENU_MAPPING[menuKey];
        const groupMenuIndex = grouppedMenus.findIndex((gropuMenu: MenuType) => {
          return gropuMenu.group_key === groupMenu.key;
        });

        if (!!~groupMenuIndex) {
          (grouppedMenus[groupMenuIndex].children || []).push({ ...menu });
        } else {
          grouppedMenus.push({
            ...groupMenu,
            group_key: groupMenu.key,
            group_name: groupMenu.name,
            children: [{ ...menu }],
          });
        }
      } else {
        grouppedMenus.push({ ...menu });
      }
    });
  }

  const dividerIndex = grouppedMenus.findIndex(
    (men: MenuType) => !men.group_key,
  );
  if (dividerIndex > 0) {
    grouppedMenus.splice(dividerIndex, 0, {
      key: MENU_DIVIDER_KEY,
      name: MENU_DIVIDER_KEY,
    });
  }

  return grouppedMenus;
};

const getOpenKeysBySelectedKey = (selectedMenuKey: string) => {
  let selectedGroupKey = null;
  if (selectedMenuKey) {
    const groupKey = selectedMenuKey.split('/')[0];
    if (!!~GROUPPED_MENU_CHILD_KEYS.indexOf(groupKey)) {
      selectedGroupKey = GROUP_MENU_MAPPING[groupKey].key;
    }
  }
  return selectedGroupKey ? [selectedGroupKey] : [];
};

const MENU_ICONS = {
  companyManagement: 'management',
  workbench: 'workbench',
  socialMediaGroup: 'media',
  liveStreamingGroup: 'live',
};

const BIconMap = {
  'outWorkbenchPortal': ComputerFilled,
  'outWorkbench': ShoppingBagFilled,
  'outBidding': BookmarkFilled,
  'outCompanyManagement': HotelFilled,
}

const renderIcon = (menu: MenuType, inlineCollapsed: boolean) => {
  const MenuIcon = BIconMap[menu.key as keyof typeof BIconMap];

  if (MenuIcon) {
    return <MenuIcon className="outer-sideber-menu-icon" style={{ fontSize: localPx2rem(inlineCollapsed ? 22 : 18) }} />
  }
  return null
}
interface SiderProps {
  collapsed: boolean;
  unCollapsedByMouseMove: boolean;
  onCollapse: Function;
  handleMenuClick: Function;
  selectedMenu: string;
  menus: MenuType[];
}
interface SiderState {
  grouppedMenus: MenuType[];
  openKeys: string[];
}

class Sider extends React.Component<SiderProps, SiderState> {
  constructor(props: SiderProps) {
    super(props);
    const grouppedMenus = getGrouppedMenus(props.menus);
    const openKeys: any[] = getOpenKeysBySelectedKey(props.selectedMenu);
    this.state = {
      grouppedMenus,
      openKeys,
    };
  }

  public componentDidUpdate(prevProps: SiderProps, prevState: SiderState) {
    if (
      prevProps.menus !== this.props.menus ||
      prevProps.selectedMenu !== this.props.selectedMenu
    ) {
      const grouppedMenus = getGrouppedMenus(this.props.menus);
      const openKeys: any[] = getOpenKeysBySelectedKey(this.props.selectedMenu);
      this.setState({ grouppedMenus, openKeys });
    }
  }

  public handleSubMenuOpenChange = (openKeys: string[]) => {
    const { openKeys: stateOpenKeys } = this.state;
    if (openKeys.length <= 0) {
      this.setState({ openKeys: [] });
    } else {
      if (stateOpenKeys.length <= 0) {
        this.setState({ openKeys: [[...openKeys][0]] });
      } else {
        this.setState({ openKeys: [[...openKeys][1]] });
      }
    }
  }

  public handleCollapse = (callapsed: boolean) => {
    const { onCollapse } = this.props;
    onCollapse && onCollapse(callapsed, false);
  }

  public handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    // @ts-ignore
    const toElementClassName = e.nativeEvent.toElement.className;
    if (!!~toElementClassName.indexOf('beehive-layout-sider-trigger')) {
      return;
    }

    const { collapsed, onCollapse } = this.props;
    if (collapsed) {
      onCollapse && onCollapse(false, true);
    }
  }

  public onMouseLeave = (e: React.MouseEvent<HTMLElement>) => {
    const { collapsed, unCollapsedByMouseMove, onCollapse } = this.props;
    if (unCollapsedByMouseMove && !collapsed) {
      onCollapse && onCollapse(true, false);
    }
  }

  public renderMenu(menu: MenuType) {
    if (menu.key === MENU_DIVIDER_KEY) {
      return (
        <Menu.Item key={MENU_DIVIDER_KEY} className={`${MENU_DIVIDER_KEY}`}>
          <span />
        </Menu.Item>
      );
    }

    const { collapsed } = this.props;
    const { grouppedMenus } = this.state;
    const hasGroupped = GROUP_MENU_KEYS.some((key: string) => {
      return !!~grouppedMenus.findIndex((menu: any) => menu.key === key);
    });

    const menuIcon = MENU_ICONS[menu.key]
      ? MENU_ICONS[menu.key]
      : menu.key.includes('CompanyManagement')
      ? MENU_ICONS['companyManagement']
      : MENU_ICONS['workbench'];

    const badge = this.props.menuCount?.find((countInfo: any) => countInfo.key === menu.key)?.count;

    return (
      <Menu.Item key={menu.key}>
        <Tooltip
          placement="right"
          title={collapsed && menu.name}
          overlayClassName="layout-sider-menu-tooltip"
        >
          <NavLink to={`/${menu.key}`} activeClassName="nav-selected">
            {(collapsed || !hasGroupped) && renderIcon(menu, collapsed)}
            {/* {(collapsed || !hasGroupped) && <Icon name={menuIcon} style={{ fontSize: localPx2rem(16) }} />} */}

            {!collapsed && <span className="menu-item-name m-l-12">{menu.name}</span>}
            {!collapsed && <span style={{ position: 'absolute', right: 16, top: 1 }}><Badge count={badge} className="m-l-8"/></span>}
          </NavLink>
        </Tooltip>
      </Menu.Item>
    );
  }

  public render() {
    const { collapsed, handleMenuClick, selectedMenu } = this.props;
    const { grouppedMenus, openKeys } = this.state;
    const selectedKeys = selectedMenu.split('/')[0];

    return (
      <Layout.Sider
        className="mpc-external-layout-sider"
        collapsible
        collapsed={collapsed}
        onCollapse={this.handleCollapse}
        // onMouseEnter={this.handleMouseEnter}
        // onMouseLeave={this.onMouseLeave}
        placement="bottom"
        trigger={<Icon name="fold-o" mode="symbol" />}
        width={localPx2rem(208)}
        collapsedWidth={localPx2rem(88)}
      >
        <div className="mpc-logo-wrapper">
          <div className={'mpc-logo ' + (collapsed ? 'collapsed' : '')} />
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedKeys]}
          openKeys={openKeys}
          onOpenChange={this.handleSubMenuOpenChange}
          onClick={handleMenuClick}
        >
          {grouppedMenus.map((menu: MenuType, index: number) => {
            if (menu.group_key) {
              const groupMenus = menu.children || [];
              return (
                <Menu.SubMenu
                  key={menu.group_key}
                  title={
                    <span>
                      {MENU_ICONS[menu.group_key] && (
                        <Icon
                          name={MENU_ICONS[menu.group_key]}
                          // size={collapsed ? 20 : 16}
                          style={{ fontSize: localPx2rem(collapsed ? 20 : 16) }}
                        />
                      )}
                      {!collapsed && (
                        <span>
                          {
                            <FormattedMessage
                              {...messages[menu.group_name || '']}
                            />
                          }
                        </span>
                      )}
                    </span>
                  }
                >
                  {groupMenus.map((groupMenu: MenuType) => {
                    return this.renderMenu(groupMenu);
                  })}
                </Menu.SubMenu>
              );
            } else {
              return this.renderMenu(menu);
            }
          })}
        </Menu>
      </Layout.Sider>
    );
  }
}

const mapState2Props = (state: any) => {
  const { menuCount } = state;
  return {
    ...menuCount,
  };
};
const mapDispatchToProps = {};
export default connect(mapState2Props, mapDispatchToProps)(Sider);
